// Betonrechner: reine Rechenlogik, keine UI, keine Seiteneffekte.
// Geometrie + Materialkonstanten, statisch. Eingaben in cm, Volumen in m³.

export const PRESETS = ["bodenplatte", "streifenfundament", "punktfundament", "saeule", "quader"];

// Materialkonstanten
const DICHTE = 2400; // kg/m³ Normalbeton
const SACK_25 = 0.0125; // m³ Ergiebigkeit eines 25-kg-Trockenbeton-Sacks (~80/m³)
const SACK_40 = 0.02; // m³ Ergiebigkeit eines 40-kg-Sacks (~50/m³)

const cm = (v) => (Number(v) || 0) / 100; // cm -> m

// Nettovolumen in m³ je Preset.
export function volumen(preset, i = {}) {
  switch (preset) {
    case "bodenplatte":
      return cm(i.laenge) * cm(i.breite) * cm(i.dicke);
    case "streifenfundament":
      return cm(i.laenge) * cm(i.breite) * cm(i.tiefe);
    case "punktfundament":
      return (Number(i.anzahl) || 0) * cm(i.laenge) * cm(i.breite) * cm(i.tiefe);
    case "saeule": {
      const r = cm(i.durchmesser) / 2;
      return (Number(i.anzahl) || 0) * Math.PI * r * r * cm(i.hoehe);
    }
    case "quader":
      return cm(i.laenge) * cm(i.breite) * cm(i.hoehe);
    default:
      throw new Error(`Unbekanntes Preset: ${preset}`);
  }
}

function round(v, n = 2) {
  const f = 10 ** n;
  return Math.round(v * f) / f;
}

// Vollständige Empfehlung inkl. Zuschlag, Gewicht, Sackzahl.
export function betonMenge(preset, inputs = {}, opts = {}) {
  const zuschlag = opts.zuschlag ?? 5; // Prozent
  const dichte = opts.dichte ?? DICHTE;
  const netto = volumen(preset, inputs);
  const brutto = netto * (1 + zuschlag / 100);
  return {
    preset,
    zuschlag,
    volumenNetto: round(netto, 3),
    volumenBrutto: round(brutto, 3),
    gewicht: Math.round(brutto * dichte), // kg, auf Bruttovolumen
    saecke25: Math.ceil(brutto / SACK_25),
    saecke40: Math.ceil(brutto / SACK_40),
  };
}
